import { selectTOSAccepted } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useTOSAccepted = () => useSelector(selectTOSAccepted);

export default useTOSAccepted;
